/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ComplianceFindingSummaryDto
 */
export interface ComplianceFindingSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof ComplianceFindingSummaryDto
     */
    findingId?: string;
    /**
     * 
     * @type {string}
     * @memberof ComplianceFindingSummaryDto
     */
    checkId?: string;
    /**
     * 
     * @type {string}
     * @memberof ComplianceFindingSummaryDto
     */
    practiceId?: string;
    /**
     * 
     * @type {string}
     * @memberof ComplianceFindingSummaryDto
     */
    controlId?: string;
    /**
     * 
     * @type {string}
     * @memberof ComplianceFindingSummaryDto
     */
    severity?: string;
    /**
     * 
     * @type {string}
     * @memberof ComplianceFindingSummaryDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ComplianceFindingSummaryDto
     */
    scanResult?: string;
}

/**
 * Check if a given object implements the ComplianceFindingSummaryDto interface.
 */
export function instanceOfComplianceFindingSummaryDto(value: object): value is ComplianceFindingSummaryDto {
    return true;
}

export function ComplianceFindingSummaryDtoFromJSON(json: any): ComplianceFindingSummaryDto {
    return ComplianceFindingSummaryDtoFromJSONTyped(json, false);
}

export function ComplianceFindingSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComplianceFindingSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'findingId': json['findingId'] == null ? undefined : json['findingId'],
        'checkId': json['checkId'] == null ? undefined : json['checkId'],
        'practiceId': json['practiceId'] == null ? undefined : json['practiceId'],
        'controlId': json['controlId'] == null ? undefined : json['controlId'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'title': json['title'] == null ? undefined : json['title'],
        'scanResult': json['scanResult'] == null ? undefined : json['scanResult'],
    };
}

export function ComplianceFindingSummaryDtoToJSON(json: any): ComplianceFindingSummaryDto {
    return ComplianceFindingSummaryDtoToJSONTyped(json, false);
}

export function ComplianceFindingSummaryDtoToJSONTyped(value?: ComplianceFindingSummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'findingId': value['findingId'],
        'checkId': value['checkId'],
        'practiceId': value['practiceId'],
        'controlId': value['controlId'],
        'severity': value['severity'],
        'title': value['title'],
        'scanResult': value['scanResult'],
    };
}

